export const lang = {
  DuplicateReference: "Duplicate Reference",
  routine: {//常规

    ecxcelFileSize: "File size cannot exceed",
    fileUploadError: "File upload failed, please make sure the file format is correct!",
    EnglishWebsiteAddress: "English website address has not been configured, please inform the administrator to configure!",
    piece: "piece",
    piece: "piece",
    ge: "piece",
    jian: "piece",
    ben: "piece",
    term: "term",
    UploadFileNoMoreThan: "Upload file no more than 1.5m",
    clickUpload: "click upload",
    DragTheFileHere: "Drag the file here, or",
    uploadFileFail: "Failed to upload file!",
    ClaimReviewInProgress: "Claim review in progress",
    AddingAndPpproving: "Adding and ppproving",
    details: "details",
    cancel_claim_results: "cancel claim results",
    Claim: "Determine Claim",
    exitClaim: "Exit Claim",
    claimResults: "Claim results",
    youHavenAavedYetAreYouSureToLeave: "You haven't saved yet. Are you sure to leave？",
    supplementary: "Here you can edit the content of the supplementary instructions",
    pleaseEnterContent: "please enter content",
    pleaseEnterTheTitleOfTheArticle: "please Enter The Title Of The Article",
    goBack: "go back",
    UserManual: "User manual",
    personalCenter: "personalCenter",
    loginOut: "login out",
    modifySuccessfullyAboutToJumpToLoginPage: "Modify successfully, about to jump to login page",
    determine: "determine",
    add: "add",
    cancel: "cancel",
    submission: "submission",
    preservation: "preservation",
    search: "search",
    reset: "reset",
    close: "close",
    tips: "tips",
    delete: "delete",
    areYouSureYouWantToDelete: "are you sure you want to delete?",
    batchDeletion: "batch deletion",
    batchRecovery: "batch recovery",
    remarksDetails: "remarks details",
    SupplementaryContent: "supplementary content",
    EditSupplementaryContent: "edit supplementary content",
    pleaseEnterKeywords: "please enter keywords",
    startDate: "start date",
    to: "to",
    endDate: "end date",
    queryField: "query field",
    edit: "edit",
    display: "display",
    displayMedium: "display medium",
    hide: "hide",
    hidden: "hidden",
    areYouSureYouWantToSetUpAPresentation: "are you sure you want to set up a presentation?",
    areYouSureYouWantToSetHide: "Are you sure you want to set hide?",
    areYouSureYouWantToRestore: "Are you sure you want to restore?",
    dataStatistics: "data statistics",
    noData: "no data",
    recovery: "recovery",
    exhibition: "exhibition",
    desperatelyLoading: "desperately loading",
    hidden: "hidden",
    displayMedium: "display medium",
    status: "status",
    operation: "operation",
    newlyAdded: "newly added",
    pleaseChoose: "please choose",
    pleaseEnterTheWebAddress: "please enter the web address",
    pleaseEnterSource: "please enter source",
    selectionDate: "selection date",
    pleaseSelectDataItem: "Please select data item!",
    yes: "yes",
    no: "no",
    start_1: "start",
    end_1: "end",
    youSelectedRepeat: "Please check if the author you selected is duplicate! "
  },

  tabPage: {//标签页
    tabOptions: "tab options",
    closeOther: "close other",
    closeAll: "close all",
  },
  index: {//主页
    goodMorning: "good morning",
    teacher: "teacher",
    fullName: "fullName",
    personalInformation: "personal information",
    positionalTitles: "positional titles",
    duties: "duties",
    education: "education",
    mailbox: "mailbox",
    telephone: "telephone",
    paper: "paper",
    patents: "patents",
    honor: "honor",
    work: "work",
    software: "software",
    project: "project"
  },
  researchProgress: {//研究成果
    type: "type",
    TitleMismatch: "Title mismatch",
    TimeDiscrepancy: "Time discrepancy",
    AuthorDiscrepancy: "Author discrepancy",
    ContentDiscrepancy: "Content discrepancy",
    Other: "Other",
    pleaseAuthorList: "please add author list",
    authorList: "author list",
    pic: "picture",
    quote_file: "quote file",
    see: "see",
    ViewNotes: "View notes",
    researchProgress: "research progress",
    recycleBin: "recycle bin",
    exitRecycleBin: "exit recycle bin",
    numberOfAuthorsCannotBeZero: "number of authors cannot be zero",
    source: "source",
    website: "website",
    author: "author",
    uploadsPeople: "uploads people",
    status: "status",
    serialNumber: "serial number",
    name: "name",
    pleaseSelectAuthorName: "please select author name",
    synchronizeToResearchGroup: "synchronize to research group",
    pleaseEnterAuthorName: "please enter author name",
    newAuthor: "new author",
    Audit: "Audit",
    RevokeAudit: "revoke audit",
    SubmitAudit: "submit audit",
    ToBeAudited: "To be audited",
    NotPass: "Not pass",
    MembersOfAssociationGroup: "Members of association group",
    PleaseSelectAnAssociatedAuthor: "Please select an associated author",
    pleaseChooseWhetherToSynchronize: "please choose whether to synchronize",
    Between2And500CharactersInLength: "Between 2 and 500 characters in length",
    paper: {
      titleOfPaper: "title of paper",
      typesOfPapers: "types of papers",
      publicationTime: "publication time",
      pleaseEnterThePaperName: "please enter the paper name",
      thesisCategory: "paper category",
      pleaseEnterPublicationTime: "please enter publication time",
      pleaseSelectPaperType: "please select paper type",

    },
    honor: {
      honorName: "honor name",
      honorLevel: "honor level",
      winningTime: "winning time",
      pleaseEnterHonorName: "please enter honor name",
      pleaseSelectHonorLevel: "please select honor level",
      pleaseEnterTheAcquisitionTime: "please enter the acquisition time"
    },
    patents: {
      inventor: "inventor",
      PleaseInventor: "Please enter the list of inventors",
      patentName: "patent name",
      patentType: "patent type",
      authorizedAnnouncementDate: "filing date",
      pleaseEnterThePatentName: "please enter the patent name",
      pleaseEnterTheAuthorizedAnnouncementDate: "please enter the authorized announcement date",
      pleaseSelectPatentCategory: "please select patent category",
      applicationNumber: "Application number",
      pleaseEnterTheApplicationNumber: "please enter the application number",
    },
    work: {
      registrationMark: "Registration no.",
      pleaseEnterTheRegistrationMark: "Please enter your registration number",
      titleOfWorks: "title of works",
      publishingTime: "publishing time",
      pleaseEnterTheTitleOfTheWork: "please enter the title of the work",
      pleaseSelectPublishTime: "please select publish time"
    }
  },
  project: {
    researchProject: "research project",
    projectName: "project name",
    projectLevel: "project level",
    applicant: "applicant",
    timeFrame: "time frame",
    pleaseEnterProjectName: "please enter project name",
    pleaseSelectProjectLevel: "please select project level",
    pleaseEnterTheNameOfTheApplicant: "Please enter the name of the applicant",
    pleaseSelectAStartTime: "please select a start time",
    pleaseSelectAEndTime: "please select a end time",
    startTimeCannotBeGreaterThanEndTime: "start time cannot be greater than end time",
    project_source: "project source",
    approved_amount: "approved amount",
    enterProjectSource: "Please enter the  project source",
    enterApprovedAmount: "Please enter the  approved amount",
    personInCharge: "person in charge",
    enterPersonInCharge: "enter PersonIn Charge"

  },
  password: {
    changePassword: "change password",
    originalPassword: "original password",
    newPassword: "new password",
    confirmPassword: "confirm password",
    submitRevision: "submit revision",
    pleaseEnterTheOriginalPassword: "please enter the original password",
    pleaseEnterNewPassword: "please enter a new password",
    pleaseConfirmThePassword: "please confirm the password",
    theNewPasswordEnteredTwiceIsInconsistent: "The new password entered twice is inconsistent"
  },
  version: {
    ReleaseNotes: "Release Notes",
    str1: "version update prompt",
    str2: "Release time",
    str3: "Version update content",
    content1: "Added user - independent system theme configuration",
    content2: "Progress, projects, and some modules materialize",
    content3: "And fixing bugs"
  },
  theme: {
    SwitchTheTheme: "Switch the theme",
    ChooseADefaultTheme: "Choose a default theme",
    PleaseConfirm: "Please confirm whether the theme configuration has been saved!",
    PleaseSelect: "Please select the custom theme first",
    SaveTheConfiguration: "Save the configuration",
    mainColor: "The main color",
    ComplementaryColor: "Complementary color",
    CustomTheme: "Custom Theme:",
    defaultTheme: "The default theme:",
    topicConfiguration: "The topic configuration",
    Newbie_Taskr: 'Novice guide',
    first_step: 'First step',
    second_step: 'Second step',
    third_step: 'Third step',
    Configure_personal_information: 'Configure personal information',
    Configure_personal_information_container: 'Please fill in the personal information, according to your actual situation, add, modify, delete or hide part of the information, you can also sort the part of the personal information',
    Add_research_progress: 'Add research progress',
    Add_research_progress_container: 'Please fill in the research progress. You can add modification, delete or set whether to display or not according to your actual situation according to the type of papers, patents, honorary works, etc',
    Add_research_projects: 'Add research projects',
    Add_research_projects_container: 'Please fill in the research progress, according to your actual situation, add modification to delete the search or set whether to display or not',
    catalog: 'Catalog',
    basic_operation: 'Basic operation',
    Create_a_research_group: 'Create a research group',
    Join_the_research_group: 'Join the research group',
    Visit_the_personal_center: 'Visit the personal center',
    Personal_homepage_management: 'Personal homepage',
    Management_of_research_progress: 'Research progress',
    Management_of_scientific_research_projects: 'Scientific research item',
    change_password: 'Change password',
    imprint: 'Imprint',
    operation_manual: 'operation manual',
    Enter_the_url: 'Enter the url',
    Enter_the_url_container: "Step by step to create a research group, the creation needs to provide the research group's domain name and other information, after the successful creation can get the research group website link and super administrator account password",
    If_you_need_to_join_an_existing_research_group: "If you need to join an existing research group, please consult the manager of the research group to get a link to the website. If you want to visit the link, fill in the information through the registration function, and wait for the approval of the administrator, you can join the research group successfully",
    Only_the_super_administrator_account: "Only the super administrator account and the account with administrator authority have the right to access the website management side, the user can login in the computer side through the top right corner of the user name under the personal center into the background of the personal center",
    After_entering_the_background_of_the_personal_center: "After entering the background of the personal center, the user can visit the personal home page from the left menu bar and jump to the editing mode of the personal home page",
    Click_the_sorting_button_in_the_head_to_sort_the_basic_information_in_the_main_area: "Click the sorting button in the head to sort the basic information in the main area, personal profile, research direction and other independent modules",
    Click_the_edit_or_exit_edit_button_in_the_header: "Click the edit or exit edit button in the header to control the display and hiding of the buttons in the main area of the page",
    Click_the_edit_button_in_front_of_each_small_module: "Click the edit button in front of each small module to enter the edit mode of the module separately",
    Click_the_show_or_hide_button_in_front_of_each_small_module: "Click the show or hide button in front of each small module to control the display or hide the module",
    After_editing_a_small_module: "After editing a small module, click the save button above the small module to save the current input information",
    After_entering_the_background_of_personal_center: "After entering the background of personal center, the user can access the research progress from the left menu bar, add, edit and delete the personal papers, patents, honorary works and other operations such as whether to display in the portal",
    After_entering_the_background_of_the_personal_center_o: "After entering the background of the personal center, users can access the scientific research projects from the left menu bar, add, edit and delete the individual scientific research projects and whether they are displayed in the portal, and other operations",
    After_entering_the_background_of_the_personal_center_s: "After entering the background of the personal center, the user can access and modify the password from the left menu bar to modify the password of his account",
    After_entering_the_background_of_the_personal_center_D: "After entering the background of the personal center, users can access the version description from the left menu bar to understand the current version information and optimization information of the research group",
    After_entering_the_background_of_the_personal_center_F: "After entering the background of personal center, users can access the operation manual from the left menu bar to understand the basic operation of the personal center management system",
  },
  RichText: {
    Thickening: "Thickening"
  },
  titleConfig: {
    Thickening: "Thickening",
    Italics: "Italics",
    Underline: "Underline",
    formatParagraph: "format paragraph",
    Strikeout: "Strikeout",
    BlockReference: "Block reference",
    InsertCode: "Insert code",
    InsertSnippet: "Insert Snippet",
    Typeface: "Typeface",
    fontSize: "font size",
    NumberedList: "Numbered list",
    ProjectList: "Project list",
    TextDirection: "Text direction",
    Alignment: "Alignment",
    FontColor: "Font color",
    backgroundColor: "background color",
    image: "image",
    video: "video",
    AddLink: "Add link",
    InsertFormula: "Insert formula",
    ClearFontFormat: "Clear font format",
    subscript: "subscript",
    Superscript: "Superscript",
    IndentLeft: "Indent left",
    IndentRight: "Indent right",
    TitleSize: "Title Size",
    TitleI: "Title I",
    TitleII: "Title II",
    TitleThree: "Title III",
    TitleIV: "Title IV",
    TitleFive: "Title V",
    TitleVI: "Title VI",
    standard: "standard",
    trumpet: "trumpet",
    Tuba: "Tuba",
    extraLargeSize: "extra-large size",
    AlignLeft: "Align left",
    AlignCenter: "Align Center",
    AlignRight: "Align right",
    Justify: "Justify",
    file: "file",
  },
  Recent_Visitors:"RECENT VISITORS",
  Quote:"Quote",
  Inquire:"Inquire",
  awesome:"Awesome",
  Established_project_time:"Established project time",
  Browse:"Browse",
  Source_File:"Source File",
  reference_materials:"Reference materials",
  Application_number:"Application number",
  Cited_content:"Cited content",
  Show_table:"Show table",
  Hide_table:"Hide table",
  Download_source_files:"Download source files",
  Add_keywords:"Add keywords",
  Starting_time:"Starting time",
  member:"member",
  Academic_organization:"ACADEMIC ORGANIZATION",
  home: "HOME",
  Go_to_home: "Go to home",
  Registration_is_deemed_consent: "Registration is deemed consent",
  protocol_of_usage: "protocol of usage",
  link_suffix: 'Personal link',
  pageview: 'Pageview',
  release: "release",
  details: "Details",
  Upload_time: "Upload time",
  Ordering_module: "Ordering module",
  Edit_your_basic_information: "Edit your basic information",
  Hide_the_module: "Hide the module",
  Display_the_module: "Display the module",
  Hide_module: "Hide module",
  Display_module: "Display module",
  cancel: "Cancel",
  confirm: "Confirm",
  delete: "Delete",
  editor: "Editor",
  save: "Save",
  name: "Name",
  Date_of_birth: "Birthday",
  identity: "Identity",
  The_title: "The title",
  position: "Position",
  The_phone: "Phone",
  fax: "Fax",
  E_mail: "E-mail",
  address: "Address",
  education_background: "Degree",
  Click_change_image: "Change image",
  Crop_Image: "Crop Image",
  Personal_profile: "BASIC INFORMATION",
  The_module_is_hidden_and_will_not_appear_on_the_home_page: "The module is hidden and will not be displayed on the home page",
  biography: "BIOGRAPHY",
  No_biography_at_present: "No biography at present",
  research_direction: "RESEARCH DIRECTION",
  Add_research_direction: "Add research direction",
  Modify_research_direction: "Modify research direction",
  Add_a_new_project: "Add new content",
  Education_experience: "EDUCATION EXPERIENCE",
  Add_educational_experience: "Add educational experience",
  Revise_your_education: "Revise your education",
  The_start_time: "The start time",
  Please_select_date: "Please select date",
  The_end_of_time: "The end of time",
  Up_to_now: "Up to now",
  school: "school",
  Please_enter_the_school_name: "Please enter the school name",
  degree: "degree",
  research_experience: "RESEARCH EXPERIENCE",
  Add_research_experience: "Add research experience",
  Revise_research_experience: "Revise research experience",
  unfold: "unfold",
  thesis_scores: "THESIS SCORES",
  Pack_up: "Pack up",
  Authorized_patents: "AUTHORIZED PATENTS",
  Undergoing_Research_Projects: "UNDERGOING RESEARCH PORJECTS",
  work: "WORK",
  Honor_rewards: "HONOR REWARDS",
  The_information_of_the_person_in_charge_that_is_pushed_in_the_team_introduction_under_the_website_management_will_be_displayed_here: "The information of the person in charge that is pushed in the team introduction under the website management will be displayed here",
  menu: "MENU",
  menu_zh: "",
  research_dynamic: "RESEARCH",
  research_dynamic_zh: "",
  news_and_trends: "NEWS AND TREDS",
  news_and_trends_zh: "",
  more: "more",
  No_dynamic: "No dynamic",
  screening: "FILTER",
  screening_zh: "",
  filter: "filter",
  All_dynamic: "All DYNAMIC",
  About_us: "About us",
  Contact_us: "Contact us",
  email: "Email",
  postcode: "postcode",
  blogroll: "Blogroll",
  Social_media: "Social media",
  return: "return",
  Module_sorting: "Module sorting",
  Exit_the_editor: "Exit editor",
  website_management: "Website management",
  Personal_center: "Personal center",
  personal_homepage: "Personal homepage",
  research_achievements: "Research achievements",
  Log_out: "Log out",
  login: "Login",
  register: "Register",
  Personal_introduction: "PERSONAL INTRODUCTION",
  Personal_introduction_zh: "个人介绍",
  Introduction_to_the_research_group: "INTRODUCTION",
  Introduction_to_the_research_group_zh: "",
  // research_direction:"研究方向",
  research_direction_zh: "",
  achievement_exhibition: "ACHIEVEMENT EXHIBIYION",
  achievement_exhibition_zh: "",
  dynamic: "DYNAMIC",
  dynamic_zh: "",
  research_equipment: "RESEARCH EQUIPMENT",
  research_equipment_zh: "",
  member_introduction: "MEMBER INTRODUCTION",
  member_introduction_zh: "",
  Research_group_management_system: "Research group management system",
  Please_enter_your_user_name_or_email_address: "Please enter your user name or email address",
  Please_enter_your_password: "Please enter your password",
  Verification_code: "Verification code",
  reload: "reload",
  Try_a_different_image: "Try a different image",
  Go_to_register: "Go to register",
  Registered_account: "Registered account",
  Mailbox_verification_code: "Mailbox verification code",
  send: "send",
  password: "password",
  Confirm_password: "Confirm password",
  User_identity: "User identity",
  Please_select_user_identity: "Please select user identity",
  To_log_in: "To log in",
  See_more_years: "See more years",
  honor: "HONOR",
  paper: "PAPER",
  patent: "PATENT",
  Patents: "PATENTS",
  All_the_time: "All TIME",
  language: "中文",
  previous_posts: "Previous posts",
  next_chapter: "Next chapter",
  share: 'Share',
  copy_href: 'Copy current address',
  source: 'source',
  Project_Time: 'Project Time',
  external_links: 'External links',
  gainer: ' Gainer',
  writer: ' Writer',
  announcer: 'Announcer',
  Hide: 'Hide',
  Display: 'Show',
  No_data: 'No data',
  Please_enter_the_content: 'Please enter the content',
  tryingToUpload: "Trying to upload ...",
  selectFile: "select file",
  pictureInsertionFailed: "picture insertion failed",
  delete: "Delete",
  new_module: "New module",
  title: "Title",
  Please_enter_your_title: "Please enter your title",
  Revise_your_profile: "Revise your profile",
  Add_custom_templates: "Add custom templates",
  modification: "Modification",
  Software: "Software",
  All: "All",
  researchprogress: "research results",
  DownloadTheReference: "Download the reference",
  principalIntroduce: "PRINCIPAL INTRODUCE",
  Thecloudteam: "The cloud team",


}


// WEBPACK FOOTER //
// ./src/VueI18n/language-en.js